import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Body2 } from '@ui/Typography'
import { AlertNotice } from '@ui/components/AlertNotice'
import { Modal } from '@ui/components/Modal'

import { Box } from '@shared/components/Box'

interface Props {
  onClose?: () => void
  daysTillSuspended: number | undefined
}

export const SwapFreeGuideTab: FC<Props> = ({ daysTillSuspended }) => {
  const { t } = useTranslation()

  return (
    <Box flex direction='column' gap='x16'>
      <Box flex direction='column' gap='x8'>
        <Modal.Body.Text medium color='text-high-em'>
          {t('Swap Free.Modal.Guide.Your Swap-Free Guide')}
        </Modal.Body.Text>
        <Body2 color='text-med-em'>
          {t('Swap Free.Modal.Guide.Here is how to maintain your Swap-Free benefit')}
        </Body2>
      </Box>
      <Box flex direction='column'>
        <Box>
          <Body2 semibold>{t('Swap Free.Level.High')}</Body2>
          <Body2 color='text-med-em'>{t('Swap Free.Modal.Guide.Your current rating.')}</Body2>
        </Box>
        <Box>
          <Body2 semibold>{t('Swap Free.Level.Medium')}</Body2>
          <Body2 color='text-med-em'>
            {t('Swap Free.Modal.Guide.You are on the right track.')}
          </Body2>
        </Box>
        <Box>
          <Body2 semibold>{t('Swap Free.Level.Low')}</Body2>
          <Body2 color='text-med-em'>{t('Swap Free.Modal.Guide.Action is needed.')}</Body2>
        </Box>
      </Box>

      <Box flex direction='column' gap='x16' fullWidth>
        <AlertNotice
          id='swap-free-guide-improve-notice'
          type='info'
          title={t('Swap Free.Modal.Guide.How to improve')}
          message={t('Swap Free.Modal.Guide.Your rating will improve as you trade', {
            daysTillSuspended,
          })}
        />
      </Box>
    </Box>
  )
}
